import { YodaBorderRadius, YodaColors, YodaFontSize } from 'yoda-ui/yodaTheme';

export const wrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '400px',
} as React.CSSProperties;

export const toolbarStyle = {
  border: `1px solid ${YodaColors.textSecondary}`,
  borderRadius: YodaBorderRadius.small,
} as React.CSSProperties;

export const editorStyle = {
  flex: 1,
  height: 'initial',
  border: `1px solid ${YodaColors.textSecondary}`,
  borderRadius: YodaBorderRadius.small,
  padding: '10px',
} as React.CSSProperties;

export const fieldStyle = {
  label: { display: 'none' },
  div: { display: 'none' },
};

export const rdwOverrides = {
  '& .rdw-option-active': {
    backgroundColor: YodaColors.primaryLighter,
    borderColor: YodaColors.blue7,
  },
  '& .rdw-dropdown-selectedtext': {
    color: YodaColors.blue7,
  },
  '& .rdw-dropdownoption-highlighted': {
    backgroundColor: YodaColors.primaryLighter,
  },
};

export const labelStyle = {
  marginTop: '0',
  marginBottom: '10px',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: YodaFontSize.small,
  fontWeight: 300,
  lineHeight: '1.2rem',
};
